module.exports = ".custom-text {\n  color: #c12c2c !important; }\n\n.space-questions {\n  padding-left: 15px !important;\n  margin-left: 15px !important; }\n"